import {Skeleton} from '@chekinapp/ui';
import {PageWrapper} from './components/PageWrapper';

export function ContactsVerificationSkeleton() {
  return (
    <PageWrapper
      title={<Skeleton className="h-[34px] w-[260px] max-w-full" />}
      intro={<Skeleton className="mt-2.5 h-4 w-[420px] max-w-full" />}
      dock={
        <Skeleton className="h-12 w-full max-w-[340px] rounded-[var(--button-radius)]" />
      }
    >
      <Skeleton className="h-12 w-full rounded-[6px]" />
      <Skeleton className="h-[42px] w-full rounded-[var(--info-box-radius)]" />
    </PageWrapper>
  );
}
